import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Import pages
import {
  SignUp,
  LogIn,
  OTPVerification,
  ForgotPassword,
  ResetPassword,
  Dashboard,
  Tasks,
  Clients,
  Projects,
  People,
  PeopleDetail,
  Roles,
  Skills,
  Timesheet,
  AllTimesheet,
  Tasklist,
  Workflow,
  ProjectsDetail,
  Workload,
  // QC Management Module
  QCManagement
  // ReleaseDetail
} from '../pages';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/tasks" element={<Tasks />} />
      <Route path="/tasks/detail/:taskId" element={<Tasks />} />
      <Route path="/tasks/tasklist" element={<Tasklist />} />
      <Route path="/tasks/timesheet" element={<Timesheet />} />
      <Route path="/tasks/all-timesheets" element={<AllTimesheet />} />
      <Route path="/tasks/workflow" element={<Workflow />} />
      <Route path="/clients" element={<Clients />} />
      <Route path="/projects" element={<Projects />} />
      <Route path="/projects/details" element={<ProjectsDetail />} />
      <Route path="/projects/detail" element={<ProjectsDetail />} />
      <Route path="/projects/detail/summary" element={<ProjectsDetail />} />
      <Route path="/projects/detail/tasks" element={<ProjectsDetail />} />
      <Route path="/projects/detail/files" element={<ProjectsDetail />} />
      <Route path="/projects/detail/logs" element={<ProjectsDetail />} />
      <Route path="/projects/detail/teams" element={<ProjectsDetail />} />
      <Route path="/projects/detail/activities" element={<ProjectsDetail />} />
      <Route path="/projects/detail/report" element={<ProjectsDetail />} />
      <Route path="/projects/detail/calendar" element={<ProjectsDetail />} />
      <Route path="/projects/summary" element={<ProjectsDetail />} />
      <Route path="/projects/logs" element={<ProjectsDetail />} />
      <Route path="/projects/teams" element={<ProjectsDetail />} />
      <Route path="/projects/activities" element={<ProjectsDetail />} />
      <Route path="/projects/report" element={<ProjectsDetail />} />
      <Route path="/projects/calendar" element={<ProjectsDetail />} />
      <Route path="/people" element={<People />} />
      <Route path="/people/detail/:peopleId" element={<PeopleDetail />} />
      <Route path="/people/detail/:peopleId/tasks" element={<PeopleDetail />} />
      <Route path="/people/detail/:peopleId/timesheets" element={<PeopleDetail />} />
      <Route path="/people/detail/:peopleId/activity" element={<PeopleDetail />} />
      <Route path="/people/detail/:peopleId/files" element={<PeopleDetail />} />
      <Route path="/people/roles" element={<Roles />} />
      <Route path="/people/workload" element={<Workload />} />
      <Route path="/people/skills" element={<Skills />} />
      
      {/* QC Management Routes */}
      <Route path="/qc/*" element={<QCManagement />} />
      
      {/* Auth Routes */}
      <Route path="/signup" element={<SignUp />} />
      <Route path="/login" element={<LogIn />} />
      <Route path="/otp-verification" element={<OTPVerification />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      {/* Add a catch-all route for 404 */}
      <Route path="*" element={<div>Page Not Found</div>} />
    </Routes>
  );
};

export default AppRoutes;
